import { select } from '@angular-redux/store';
import { Component, forwardRef, Inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Account } from "sharedFeatures/sharedModels";
import { ChangePaymentWinComponent } from './change-payment-win.component';

@Component({
    selector: 'change-payment-win-body',
    templateUrl: './change-payment-win-body.component.html',
    styleUrls: ['./change-payment-win-body.component.less']
})

export class ChangePaymentWinBodyComponent {

    // Unsubscribe event
    private storeUnsubscribe = new Subject<void>();

    @select(['account', 'accountData'])
    readonly accountData$!: Observable<Account>;

    constructor(
        @Inject(forwardRef(() => ChangePaymentWinComponent)) private parent: ChangePaymentWinComponent) {
    }    

    ngOnDestroy() {
        // Unsubscribe from the redux store
        this.storeUnsubscribe.next();
        this.storeUnsubscribe.complete();
    }

    onContinue(): void {
        if (this.parent.billingComponent)
            this.parent.billingComponent.LoadSSOLink("change_card");

        //this.parent.hostWindow.setZIndex(PopupComponent.getTopestZ() + 1);
        this.parent.close();
    }
}